import React from "react";
import ReactDOM from "react-dom/client";

import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/motion.css";

import App from "./App";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
